import { useState, useCallback } from 'react';

// Local hooks.
import useMountState from './useMountState';

/**
 * Create a modal with a value, onClick and onClose handler.
 *
 * @return {Array} An array containing the values.
 */
export default () => {
  const [modal, setModal] = useState(false);
  const isMounted = useMountState();
  const onClose = useCallback(() => {
    if (isMounted.current) {
      setModal(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modal, setModal, isMounted]);

  const onClick = ({ value }) => setModal(value);

  return [modal, onClick, onClose];
};
